/* eslint-disable no-restricted-syntax */
/* eslint-disable brace-style */
import {
  AccountId,
  CardProTemplateData,
  GetLedgerModificationDataInterface,
  LedgerId,
} from "@totalenergiescode/mobility-business-rev-form-data/components";
import { GraphQLClient } from "graphql-request";

import { GetLedgerModificationDataQuery } from "@/api/graphql/ledgers/getModificationTemplate/queries";

export class GetLedgerModificationData
  implements GetLedgerModificationDataInterface
{
  constructor(private graphqlClient: GraphQLClient) {}

  async search(
    accountId: AccountId,
    ledgerId: LedgerId,
  ): Promise<CardProTemplateData> {
    const headers: Record<string, string> = {};
    headers["X-ACCOUNT-ID"] = accountId;

    const result = await this.graphqlClient.request(
      GetLedgerModificationDataQuery,
      {
        request: {
          ledgerId: ledgerId,
        },
      },
      headers,
    );
    const data = result.LedgersMsGetLedgerModificationData;

    if (!data) {
      throw new Error("No data returned from LedgersMsGetLedgerCreationData");
    }

    return {
      category: data.category ?? "",
      isUnavailable: !!data.isUnavailable,
      rawFormData: data.rawFormData ?? "",
    };
  }
}
